/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSidebarBlurbs_vipUserRelationship$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_vipUserRelationship$ref: FragmentReference;
export type PdpRespContainer_vipUserRelationship = {|
  +$fragmentRefs: PdpRespSidebarBlurbs_vipUserRelationship$ref,
  +$refType: PdpRespContainer_vipUserRelationship$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_vipUserRelationship",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b3496aec22adf532daa3156b8e973f56';
module.exports = node;
